import { PLUGIN_NAME } from './const';
export * from './number/i18n';
export * from './date/i18n';
export const name = PLUGIN_NAME;
